import { render, staticRenderFns } from "./qm-icon.vue?vue&type=template&id=4024e3e8"
import script from "./qm-icon.vue?vue&type=script&lang=js"
export * from "./qm-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports